export const DELIMITER_OPTIONS = [
    { value: ',', label: 'Comma (,)' },
    { value: ';', label: 'Semicolon (;)' },
    { value: '\t', label: 'Tab (\\t)' },
    { value: ' ', label: 'Space ( )' },
    { value: '|', label: 'Pipe (|)' },
]
export const CSV_FORM_CONFIG_STEP =0
export const CSV_LEAD_SOURCE_MAPPING_FIELDS_STEP =1
export const CSV_LEAD_SOURCE_PREVIEW_TABLE_STEP = 2